import React from "react";
import Text from "components/text/Text";
import styles from "./OuterServicesRefinements.module.scss";
import strings from "assets/strings";
//import { DropdownLocalAlgolia } from "components/dropdownLocalAlgolia/DropdownLocalAlgolia";
import { aroundRadiusOptions, /*algoliaAttributes*/ } from "assets/constants";
import { checkIfParamExist } from "helpers";
import { CustomDropdown } from "components/customDropdown/CustomDropdown";
import { DropdownLocalAlgoliaWithSearch } from "components/dropdownLocalAlgoliaWithSearch/DropdownLocalAlgoliaWithSearch";

const queryString = window.location.search;
const urlSearchParams = new URLSearchParams(queryString);

export const OuterServicesRefinements = () => {
  return (
    <div className={`${styles.container} col-lg-3`}>
      <aside className={styles.aside}>
        <Text
          className={styles.title}
          text={strings.globalStrings.filterBy}
        />
        {/* <DropdownLocalAlgolia
          multiSelect
          isPopup
          attribute={algoliaAttributes.MedicalServices}
          title={strings.medicalCentersSearchResults.servicesInClinic}
          titlePopup={strings.medicalCentersSearchResults.chooseService}
          subTitlePopUp={strings.medicalCentersSearchResults.canChooseService}
        /> */}

        <DropdownLocalAlgoliaWithSearch
          attribute="name"
          title={strings.medicalCentersSearchResults.searchByName}
        />

        {!checkIfParamExist('loc') && <DropdownLocalAlgoliaWithSearch

          attribute="city"
          title={strings.globalStrings.city}

        />
        }

        {checkIfParamExist('loc') && <CustomDropdown
          selectOptions={aroundRadiusOptions}
          title={strings.globalStrings.distance}
          slectedValue={urlSearchParams.has("r") && Number(urlSearchParams.get("r")) !== 10000 ? Number(urlSearchParams.get("r")) : 10000}
          defaultValue={10000}
        />}

      </aside>
    </div>
  );
};
